import {dataHooks} from '@wix/data-hooks'

export const experienceDetailsDataHooks = dataHooks<{
  root: {}
}>('experience-details')
